/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum CustomerDocumentRequestChannel {
    Email = 'Email',
    Stella = 'Stella'
  }

    export const CustomerDocumentRequestChannelTranslocoMap: Record<CustomerDocumentRequestChannel, string> = {
    [CustomerDocumentRequestChannel.Email]: 'customerDocumentRequestChannel.email',
    [CustomerDocumentRequestChannel.Stella]: 'customerDocumentRequestChannel.stella',
    };

    export const CustomerDocumentRequestChannelOptions = [
  { value: CustomerDocumentRequestChannel.Email, labelKey: 'customerDocumentRequestChannel.email' },
  { value: CustomerDocumentRequestChannel.Stella, labelKey: 'customerDocumentRequestChannel.stella' },
    ];

